module.exports = __webpack_public_path__ + "pcsg/img/challenge.827a97cc.png";